import {
    Box,
    Button,
    DialogContent,
    DialogTitle,
    Grid,
    Typography,
} from '@mui/material'
import { useTranslation } from 'react-i18next'
import styles from '../paymentDialog.style'
import usePaymentContext from '../hook/usePaymentContext'
import { PaymentTypeList } from './PaymentTypeList'
import PaymentMainSection from '../PaymentMainSection'
import { useCallback, useMemo } from 'react'
import { useScreenSize } from 'hooks/useScreenSize/useScreenSize'
import PaymentDialogTablet from '../PaymentDialogTablet'
import { PaymentMainSectionMobile } from '../PaymentMainSectionMobile'

function SinglePaymentMobile() {
    const { onCloseDialogWithReset, onSubmitPayment } = usePaymentContext()
    return (
        <PaymentMainSectionMobile
            onBack={onCloseDialogWithReset}
            onSubmitPayment={onSubmitPayment}
        />
    )
}
function SinglePayment() {
    const {
        isReadyToProceedPayment,
        paymentTypeLists: paymentSettings,
        selectedPaymentType,
        onSelectPaymentType,
        addTipsMode,
        onEnterAddTipsMode,
        onExitAddTipsMode,
        onSubmitPayment,
        isAddTipsEnabled,
        useSplitPayment,
        onSetSplitPayment,
        isNegativeTotalDue,
        hasAwaitingProcessTransaction,
        expectAmount,
    } = usePaymentContext()

    const { t } = useTranslation()

    const onClickAddTipsButton = useMemo(
        () => (addTipsMode ? onExitAddTipsMode : onEnterAddTipsMode),
        [addTipsMode, onExitAddTipsMode, onEnterAddTipsMode],
    )

    const onSwitchToSplitPayment = useCallback(() => {
        if (addTipsMode) onExitAddTipsMode()
        onSetSplitPayment(true)
    }, [addTipsMode, onExitAddTipsMode, onSetSplitPayment])

    return (
        <>
            <DialogTitle
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                }}
            >
                <Typography
                    variant="body1"
                    sx={{
                        alignSelf: 'center',
                    }}
                >
                    {t('finish.label.payment')}
                </Typography>
            </DialogTitle>
            <DialogContent sx={styles.dialogContainer}>
                <Grid container direction="row" spacing={1}>
                    <Grid item xs={2}>
                        <Box sx={styles.leftPanelContainer}>
                            <Box
                                sx={{
                                    height: 'calc(75svh - 150px)', // remove with bottom section's height
                                    overflowY: 'auto',
                                }}
                            >
                                <PaymentTypeList
                                    selectedPaymentSettingID={
                                        selectedPaymentType?.paymentSettingID
                                    }
                                    onSelect={onSelectPaymentType}
                                    paymentTypeList={paymentSettings}
                                    onExitAddTipsMode={onExitAddTipsMode}
                                    isNegativeTotalDue={isNegativeTotalDue}
                                    expectAmount={expectAmount.toNumber()}
                                />
                            </Box>
                            <Box sx={styles.bottomleftPanel}>
                                {isAddTipsEnabled && (
                                    <Box>
                                        <Button
                                            size="large"
                                            variant={
                                                addTipsMode
                                                    ? 'contained'
                                                    : 'outlined'
                                            }
                                            color="primary"
                                            fullWidth
                                            onClick={onClickAddTipsButton}
                                            disabled={
                                                !isReadyToProceedPayment ||
                                                hasAwaitingProcessTransaction
                                            }
                                            sx={styles.confirmButton}
                                        >
                                            {t('finish.button.add_tips')}
                                        </Button>
                                    </Box>
                                )}

                                {useSplitPayment && (
                                    <Box
                                        sx={{
                                            mt: 1,
                                            bottom: 5,
                                            position: 'absolute',
                                            width: '100%',
                                        }}
                                    >
                                        <Button
                                            size="large"
                                            variant="outlined"
                                            color="primary"
                                            fullWidth
                                            onClick={onSwitchToSplitPayment}
                                            disabled={
                                                !isReadyToProceedPayment ||
                                                isNegativeTotalDue
                                            }
                                            sx={styles.confirmButton}
                                        >
                                            {t('finish.button.split_payment')}
                                        </Button>
                                    </Box>
                                )}
                            </Box>
                        </Box>
                    </Grid>
                    <Grid item xs={10} sx={styles.mainPanelContainer}>
                        <PaymentMainSection onSubmitPayment={onSubmitPayment} />
                    </Grid>
                </Grid>
            </DialogContent>
        </>
    )
}
export function SinglePaymentContainer() {
    const { isMobile, isMediumScreen } = useScreenSize()

    return (
        <>
            {isMobile ? (
                <SinglePaymentMobile />
            ) : isMediumScreen ? (
                <PaymentDialogTablet />
            ) : (
                <SinglePayment />
            )}
        </>
    )
}
